import { useQuery } from "@tanstack/react-query";
import type { LimitedUseRxNavQueryOptions, RxNavQueryRequests } from "./types";

export interface UseRxNavDrugQueryArgs<TError = Error, TData = RxNavQueryRequests["drugs"]["response"]>
  extends LimitedUseRxNavQueryOptions<"drugs", TError, TData> {}

export const useRxNavDrugQuery = <TError = Error, TData = RxNavQueryRequests["drugs"]["response"]>({
  request,
  ...options
}: UseRxNavDrugQueryArgs<TError, TData>) =>
  useQuery({
    queryKey: ["rx-nav", "drugs", request],
    queryFn: async () => {
      const url = encodeURI(`https://rxnav.nlm.nih.gov/REST/drugs.json?name=${request.name}`);
      const result = await fetch(url);
      return await result.json();
    },
    ...options,
  });
